export const TEAM_DELETE_TOOL_NAME = 'TeamDelete'
